var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Form',{attrs:{"submit-function":_vm.updateSiteInfo,"editable":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }